export default __webpack_public_path__ + "static/char-v-62-ja-55cdbdede3187514eae08bf66d2cfcb5.mp4";